import { useMemo } from 'react';
import Link from './link';
import Header from './header';
import UptimeRobot from './uptimerobot';
import Package from '../../package.json';

function App() {

  const apikeys = useMemo(() => {
    const { ApiKeys } = window.Config;
    if (Array.isArray(ApiKeys)) return ApiKeys;
    if (typeof ApiKeys === 'string') return [ApiKeys];
    return [];
  }, []);

  return (
    <>
      <Header />
      <div className='container'>
        <div id='uptime'>
          {apikeys.map((key) => (
            <UptimeRobot key={key} apikey={key} />
          ))}
        </div>
        <div id='footer'>
          <p>状态每&nbsp;1&nbsp;分钟自动更新&nbsp;|&nbsp;手动刷新将立即更新</p>
          <p>2013&nbsp;-&nbsp;2023&nbsp;&copy;&nbsp;SIRE&nbsp;-&nbsp;<Link to='/' text='思锐' /></p>
        </div>
      </div>
    </>
  );
}

export default App;
